<template>
  <div class="factoryTools">
    <div class="header">
      <el-tabs :value="tabPaneValue">
        <el-tab-pane label="烧录工单" name="first">
          <span
            class="childTabs"
            :class="{ activeLink: toolsLink == 'firstLink' }"
            @click="toolsClick('firstLink')"
            >烧录工单</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" style="margin-right:15px">
              <el-tooltip v-if="tabPaneValue == 'first'" class="item" content="只看我的工单" placement="bottom" :open-delay="300">
                <el-checkbox v-model="searchConditionForm.onlyMy" @change="getOutwardOrderSearch">我的工单</el-checkbox>
              </el-tooltip>
            </div>
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button type="primary" size="small" @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>        
      </el-tabs>
      <!-- 查询条件 -->
      <el-form v-if="tabPaneValue == 'first' && isMoreSearch && toolsLink == 'firstLink'"
        :inline="true" :model="searchConditionForm" class="demo-form-inline">
        <div class="searchConditionBox">
          <el-form-item label="烧录工单" size="small">
            <el-input v-model="searchConditionForm.orderNumber" placeholder="烧录工单号" clearable
              @keyup.enter.native="getOutwardOrderSearch()" />
          </el-form-item>
          <el-form-item label="组装工单" size="small">
            <el-input v-model="searchConditionForm.productionOrder" placeholder="组装单号" clearable
              @keyup.enter.native="getOutwardOrderSearch()" />
          </el-form-item>
          <el-form-item label="外发时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDateTime"
              type="datetime"
              placeholder="外发开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange('searchConditionForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDateTime"
              type="datetime"
              placeholder="外发结束时间"
              @change="endDateChange('searchConditionForm')"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="工单状态" size="small">
            <el-select
              v-model="searchConditionForm.status"
              placeholder="选择工单状态"
              filterable
              clearable
              multiple
              collapse-tags
            >
              <el-option
                v-for="(item, index) in pullDownData.outwardStatusList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="searchConditionForm.userId"
              placeholder="所有者或检验员"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'searchConditionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>      
    </div>
    <!-- 烧录工单列表 -->
    <div class="contentBox">
      <div
        v-if="tabPaneValue == 'first' && toolsLink == 'firstLink'"
        class="rightContent"
      >
        <el-table stripe border style="width: 100%" height="100%" size="mini"
          :data="tableData" @sort-change="sortChange"
        >
          <el-table-column type="index" align="center"
            :width="pagination.endIndex >= 1000 ? 80 : 50"
            :index="pagination.beginIndex"
          ></el-table-column>
          <el-table-column
            label="烧录工单" min-width="110px" align="center" prop="orderNumber" show-overflow-tooltip sortable="custom"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="iqc(scope.row)">
                {{ scope.row.orderNumber }}
              </span>
            </template>
          </el-table-column>
          <el-table-column max-width="110px" 
            label="产品型号" prop="product" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.product">
                {{ scope.row.product.code }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column  max-width="110px" min-width="95px"
            label="固件版本" prop="firmware" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.firmware">
                {{ scope.row.firmware.version }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column max-width="110px" 
            label="组装工单" prop="productionOrder" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.productionOrder">
                {{ scope.row.productionOrder.orderNumber }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column max-width="110px" 
            label="销售订单" prop="customerOrder" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customerOrder">
                {{ scope.row.customerOrder.orderNumber }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column width="95px" 
            label="工单所有者" prop="createUser" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.createUser">
                {{ scope.row.createUser.name }} ({{ scope.row.createUser.employeeNum }})
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" 
            label="外发时间" prop="outwardDateTime" align="center" show-overflow-tooltip sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.outwardDateTime">
                {{ scope.row.outwardDateTime }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" 
            label="校验时间" prop="qcDateTime" align="center" show-overflow-tooltip sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.qcDateTime">
                {{ scope.row.qcDateTime }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column width="95px" 
            label="检验员" prop="qcUser" align="center" show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.qcUser">
                {{ scope.row.qcUser.name }} ({{ scope.row.qcUser.employeeNum }})
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            label="状态" prop="status" align="center" show-overflow-tooltip sortable="custom"
            width="95px"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.status">
                {{ scope.row.status.title }}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
      <el-table-column
        class-name="operation"
        label="操作"
        align="center" width="95px"
      >
        <template slot-scope="scope" v-if="scope.row.status">    
          <el-tooltip v-if="scope.row.status.code=='UPLOAD_FAIL'"
            class="item" effect="dark" content="重新上传" placement="top" :open-delay="300"
          >
            <i @click="retryOutwardOrder($event, scope.row)"
              class="iconfont icon-chongqi"></i>
          </el-tooltip>       
          <el-tooltip v-if="scope.row.status.code!='PASS'"
            class="item" effect="dark" content="删除" placement="top" :open-delay="300"
          >
            <i @click="deleteOutwardOrder($event, scope.row)"
              class="el-icon-delete"></i>
          </el-tooltip> 
          <el-tooltip v-if="scope.row.status.code!='PASS'"
            class="item" effect="dark" content="交接" placement="top" :open-delay="300"
          >
            <i @click="handover($event, scope.row)"
              class="iconfont icon-jiaojie"></i>
          </el-tooltip>
          <span v-if="scope.row.status.code=='PASS'">-</span>
        </template>
      </el-table-column>         
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getOutwardOrderSearch"
        ></pagination>
      </div>   
    </div>
    <myDialog ref="myDialog" width="680px"
      @rollBack="skipIQC"
      :title="'烧录工单【'+dialogForm.orderNumber+'】'+dialogForm.status.title" @submitData="submitData" @dialogClose="dialogClose"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="烧录工单" size="small" class="inlineItem">  
            <el-input v-model="dialogForm.orderNumber" :readonly="true"/>
          </el-form-item>
          <el-form-item label="状态" size="small" class="inlineItem">
            <el-input v-model="dialogForm.status.title" :readonly="true"/>
          </el-form-item>
          <el-form-item label="裸机编码" size="small" class="inlineItem">
            <el-input v-if="dialogForm.itemCode" v-model="dialogForm.itemCode" :readonly="true"/>
            <el-input v-else value="-" :readonly="true"/>
          </el-form-item>
          <el-form-item label="产品型号" size="small" class="inlineItem">
            <el-input v-model="dialogForm.product.code" :readonly="true"/>
          </el-form-item>
          <el-form-item label="固件版本" size="small" class="inlineItem">
            <el-input v-model="dialogForm.firmware.version" :readonly="true"/>
          </el-form-item>
          <el-form-item label="外发时间" size="small" class="inlineItem">
            <el-input v-model="dialogForm.outwardDateTime" :readonly="true"/>
          </el-form-item>
          <el-form-item label="组装工单" size="small" class="inlineItem">
            <el-input v-if="dialogForm.productionOrder" v-model="dialogForm.productionOrder.orderNumber" :readonly="true"/>
            <el-input v-else value="-" :readonly="true"/>
          </el-form-item>
          <el-form-item label="销售订单" size="small" class="inlineItem">
            <el-input v-if="dialogForm.customerOrder" v-model="dialogForm.customerOrder.orderNumber" :readonly="true"/>
            <el-input v-else value="-" :readonly="true"/>
          </el-form-item>
          <el-form-item label="工单所有者" size="small" class="inlineItem">
            <el-input v-model="dialogForm.createUser.name"/>
          </el-form-item>
          <el-form-item label="检验时间" size="small" class="inlineItem">
            <el-input v-if="dialogForm.qcDateTime" v-model="dialogForm.qcDateTime" :readonly="true"/>
            <el-input v-else value="-" :readonly="true"/>
          </el-form-item>
          <el-form-item label="检验员" size="small" class="inlineItem">
            <el-input v-if="dialogForm.qcUser" v-model="dialogForm.qcUser.name" :readonly="true"/>
            <el-input v-else value="-" :readonly="true"/>
          </el-form-item>
          <el-form-item label="镜像文件" size="small" v-if="dialogForm.status.code=='PASS'" :class="{'inlineItem':dialogForm.status.code!='PASS'}">
            <span>
              <span :readonly="true" class="none_border textOverflow"
                v-for="(item, index) in dialogForm.imageList" :key="index">
                <span :title="item.name" class="allowSkip" @click="downloadFile(item.id, '镜像文件')">{{item.name}}</span>
              </span>
            </span>
          </el-form-item>
          <el-form-item label="二次校验" size="small">
            <input prop="imageList"
              ref="fileUpload"
              class="fileUpload"
              type="file" multiple="multiple"
              @change="fileChange('fileUpload')"
            />
            <div v-if="isError" class="el-form-item__error">
              请选择至少5个镜像文件！
            </div>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <myDialog ref="addOutwardOrder" width="780px"
      title="新建烧录工单"  @dialogClose="addOutwardOrderClose" @submitData="addOutwardOrderData"
    >
      <template slot="content">
        <div class="tips tipsBox">
          <span class="title" style="color:#E6A23C">温馨提示：</span>
          <span class="text">因外发邮件的频率限制，如未收到邮件通知请删除此单后重新发起。</span>
        </div>
        <el-form
          ref="outwardOrderForm"
          :model="addOutwardForm"
          :rules="addOutwardRules"
          :label-width="labelWidth"
        >
        <el-form-item
            label="烧录工单"
            size="small"
            prop="orderNumber"
            class="inlineItem"
          >
            <el-input
              v-model="addOutwardForm.orderNumber"
              placeholder="烧录工单"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            label="销售单号"
            size="small"
            prop="customerOrderNumber"
            class="inlineItem"
          >
            <el-input
              v-model="addOutwardForm.customerOrderNumber"
              placeholder="销售单号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="产品类别" prop="productType" size="small" class="inlineItem">
            <el-select
              v-model="addOutwardForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small" prop="productId" class="inlineItem">
            <el-select
              v-model="addOutwardForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
              @change="productChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Flash固件版本" size="small" prop="flashFwId" class="inlineItem">
            <el-select
              v-model="addOutwardForm.flashFwId"
              placeholder="选择固件版本"
              filterable
              clearable
            >
            <el-option
                  v-for="(item, index) in pullDownData.flashFwList"
                  :key="index"
                  :label="item.version"
                  :value="item.id"
              >{{ item.version }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="MCU版本" size="small" prop="mcuFwId" class="inlineItem">
            <el-select
              v-model="addOutwardForm.mcuFwId"
              placeholder="选择MCU版本"
              filterable
              clearable
            >
            <el-option
                  v-for="(item, index) in pullDownData.mcuFwList"
                  :key="index"
                  :label="item.version"
                  :value="item.id"
              >{{ item.version }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="WIFI固件版本" size="small" prop="wiFiFwId" class="inlineItem">
            <el-select
              v-model="addOutwardForm.wiFiFwId"
              placeholder="选择固件版本"
              filterable
              clearable
            >
            <el-option
                  v-for="(item, index) in pullDownData.wiFiFwList"
                  :key="index"
                  :label="item.version"
                  :value="item.id"
              >{{ item.version }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="蓝牙固件版本" size="small" prop="btFWId" class="inlineItem">
            <el-select
              v-model="addOutwardForm.btFwId"
              placeholder="选择固件版本"
              filterable
              clearable
            >
            <el-option
                  v-for="(item, index) in pullDownData.btFwList"
                  :key="index"
                  :label="item.version"
                  :value="item.id"
              >{{ item.version }}</el-option>
            </el-select>
          </el-form-item>
         
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import { apiUploadFile, apiDownloadFile } from "@/api/filesUpload.js";
import orderTableSelect from "@/components/orderTableSelect.vue";
import {
  apiOutwardIqc,
  apiOutwardSkipIqc,
  apiOutwardDelete,
  apiOutwardRetry,
  apiOutwardStatusList,
  apiOutwardOrderSearch,
  apiOutwardOrderAdd
} from "@/api/outwardOrder.js";
import {
  apiProductTypeList,
  apiProductList,
} from "@/api/customerOrder.js";
import { apiFirmwareListVersion } from "@/api/firmwareManage.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/outwardOrder" },
  components: {
    pagination,
    myDialog,
    orderTableSelect
  },
  data() {
    return {
      tabPaneValue: "first",
      toolsLink: "firstLink",
      isMoreSearch: false,
      isError: false,
      searchConditionForm: {},
      pullDownData: {
        orderStatusList: [],
        productTypeList: [],
        productList: [],
        firmwareList: [],
        flashFwList: [],
        mcuFwList: [],
        wiFiFwList: [],
        btFwList: [],
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {
        productionOrder:{},
        product:{},
        firmware:{},
        createUser:{},
        qcUser:{},
        status:{},
        imageList:[]
      },
      addOutwardForm:{},
      dialogRules: {
        imageList: [
          {type: 'array', min: 5, max: 100, message: '需要 5 到 100 个镜像文件', trigger: 'blur' }
        ]
      },
      addOutwardRules: {
        orderNumber: [
          { required: true, message: "烧录工单不能为空！", trigger: "change" },
        ],
        customerOrderNumber: [
          { required: true, message: "销售单号不能为空！", trigger: "change" },
        ],
        productType: [
          { required: true, message: "产品类别不能为空！", trigger: "change" },
        ],
        productId: [
          { required: true, message: "产品型号不能为空！", trigger: "change" },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  watch: {
    tabPaneValue: function () {
      this.$moreSearchStyle();
      if (this.tabPaneValue == "first") {
        if (this.toolsLink == "firstLink") {
          this.getOutwardOrderSearch();
        } else {
          this.$nextTick(() => {
            this.$refs.commandPage.getOutwardOrderSearch();
          });
        }
      }
    },
    toolsLink: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "firstLink") {
        this.getOutwardOrderSearch();
      } else {
        this.$nextTick(() => {
          this.$refs.commandPage.pagination.currentPage = 1;
          this.$refs.commandPage.getFactoryCommandSearch();
        });
      }
    },
  },
  methods: {
    skipIQC() {
      if (this.dialogForm.status.code!='WAIT_CHECK') {
          this.$message({
            type: "error",
            message: "烧录工单状态错误，非【待检验】状态不能强制跳过烧录校验！",
          });
      } else {
        const h = this.$createElement;
        this.$msgbox({
          title: `提示`,
          message: h("div", null, [
            h("span", null, `请输入烧录工单号:【`),
            h(
              "i",
              { style: "color: var(--themeColor)" },
              this.dialogForm.orderNumber
            ),
            h("span", null, `】以确认强制跳过烧录校验！`),
          ]),
          showCancelButton: true,
          confirmButtonText: `确认`,
          cancelButtonText: "取消",
          closeOnClickModal: false,
          showInput: true,
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (instance.inputValue === this.dialogForm.orderNumber) {
                done();
              } else {
                this.$message({
                  type: "warning",
                  message: `工单号输入错误，无法继续！`,
                });
              }
            } else {
              done();
            }
          },
        }).then(async () => {
          let res = {};
          res = await apiOutwardSkipIqc({
              id: this.dialogForm.id,
              force: true
            });        
          if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            this.pagination.currentPage = 1;
            this.getOutwardOrderSearch();
            this.$message({
              message: "已强制跳过了烧录校验流程，可以【开始生产】组装工单了！",
              type: "success",
            });
          }
        });
      }
    },
    // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
    },
    handover(e, row) {
      e.target.blur();
      this.$message({
        message: "工单交接【"+row.orderNumber+"】，敬请期待！",
        type: "success",
      });
    },
    retryOutwardOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "重新上传", "烧录工单").then(
        async () => {
          const res = await apiOutwardRetry({
            id: row.id,
          });
          if (res.code == 0) {
            this.getOutwardOrderSearch();                
            this.$message({
              message: "重新上传任务已发起，上传结果将发送到您的邮箱，请留意！",
              type: "warning",
            });
          }
        }
      );
    },
    deleteOutwardOrder(e, row) {
      e.target.blur();
      this.$allOperation({ name: row.orderNumber }, "删除", "烧录工单").then(
        async () => {
          const res = await apiOutwardDelete({
            id: row.id,
          });
          if (res.code == 0) {
            this.getOutwardOrderSearch();                
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        }
      );
    },
    // 选择文件
    async fileChange(refName) {
      this.$set(this.dialogForm, "imageList", this.$refs[refName].files);
    },
    downloadFile(fid, fileName, secretKey) {
      let a = document.createElement("a");
      a.download = fileName + "下载";
      a.href = apiDownloadFile(fid, secretKey);
      a.style.display = "none";
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    iqc(row) {
      this.dialogForm = row;
      this.$refs.myDialog.dialogVisible = true;
    },
    //新建烧录工单
    addNewBtn() {
      this.$refs.addOutwardOrder.dialogVisible = true;
      this.pullDownData.productList = [];
      this.pullDownData.firmwareList = [];
      this.pullDownData.flashFwList = [];
      this.pullDownData.mcuFwList = [];
      this.pullDownData.wiFiFwList = [];
      this.pullDownData.btFwList = [];
    },
    // 产品类别下拉(目前仅支持选择音频产品)
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData.productList = res.data;
      }
    },
    // 固件版本下拉
    async getFirmwareList(tabProductId) {
      const res = await apiFirmwareListVersion({
        productId: tabProductId
      });
      if (res.code == 0) {
        this.pullDownData.flashFwList = res.data.filter(item =>item.type.code=='Flash');
        this.pullDownData.mcuFwList = res.data.filter(item =>item.type.code=='MCU');
        this.pullDownData.wiFiFwList = res.data.filter(item =>item.type.code=='WiFi');
        this.pullDownData.btFwList = res.data.filter(item =>item.type.code=='Bluetooth');
      }
    },
    //根据产品类别改变 获取产品信息
    productTypeChange(value) {
      this.$set(this.addOutwardForm, 'productId', '')
      this.$set(this.addOutwardForm, 'flashFwId', '')
      this.$set(this.addOutwardForm, 'mcuFwId', '')
      this.$set(this.addOutwardForm, 'wiFiFwId', '')
      this.$set(this.addOutwardForm, 'btFwId', '')
      this.pullDownData.firmwareList = [];
      this.pullDownData.flashFwList = [];
      this.pullDownData.mcuFwList = [];
      this.pullDownData.wiFiFwList = [];
      this.pullDownData.btFwList = [];
      if (value) {
        this.getProductList(value);
      }
    },
    // 根据产品类别改变 获取固件版本
    productChange(value) {
      this.$set(this.addOutwardForm, 'flashFwId', '')
      this.$set(this.addOutwardForm, 'mcuFwId', '')
      this.$set(this.addOutwardForm, 'wiFiFwId', '')
      this.$set(this.addOutwardForm, 'btFwId', '')
      this.pullDownData.flashFwList = [];
      this.pullDownData.mcuFwList = [];
      this.pullDownData.wiFiFwList = [];
      this.pullDownData.btFwList = [];
      if (value) {
        this.getFirmwareList(value);
      }
    },

    addOutwardOrderData(){
      this.$refs.outwardOrderForm.validate(async valid => {
        if (valid) {
          const res = await apiOutwardOrderAdd({
              ...this.addOutwardForm
            });
            if (res.code == 0) {
              this.onSearch();
              this.$refs.addOutwardOrder.dialogVisible = false;
              this.$message({
                message: "新建成功",
                type: "success"
              });
            } else if(res.code == 1024) {
              this.onSearch();
              this.$refs.addOutwardOrder.dialogVisible = false;
              this.$message({
                message: res.msg,
                type: "success"
              });
            }
        } else {
          return false;
        }
      });
    },
    
    // 确认新建
    submitData() {
      if (this.dialogForm.imageList) {
        this.$refs.dialogForm.validate(async (valid) => {
          if (valid) {
            if (!this.dialogForm.imageList) {
              this.isError = true;
              this.$message({
                message: "至少需要上传5个镜像文件！",
                type: "error",
              });
              return false;
            } else if (this.dialogForm.imageList.length<5) {
              this.isError = true;
              this.$message({
                message: "至少需要上传5个镜像文件！",
                type: "error",
              });
              return false;
            } else if (this.dialogForm.imageList.length>50) {
              this.isError = true;
              this.$message({
                message: "最多只能上传50个镜像文件！",
                type: "error",
              });
              return false;
            }
            
            this.isError = false;
            
            let res = {};
            let fidList = new Array();
            let index=0;
            for await(let item of this.dialogForm.imageList){
                let fd = new FormData();
              fd.append("file", item);
              res = await apiUploadFile(fd);
              if (res.code == 0) {
                fidList[index++] = res.fid;
              } else {
                return false;
              }
            }
            res = await apiOutwardIqc({
              id: this.dialogForm.id,
              fid: fidList
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.pagination.currentPage = 1;
              this.getOutwardOrderSearch();
              this.$message({
                message: "IQC校验成功，请入库！",
                type: "success",
              });
            }
          }
        });
      } else {
        this.$refs.myDialog.dialogVisible = false;
      }
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {        
        productionOrder:{},
        product:{},
        firmware:{},
        createUser:{},
        qcUser:{},
        status:{},
        imageList:[]
      };
      this.$refs.fileUpload = [];
      this.isError = false;
    },
    // 关闭对话框
    addOutwardOrderClose() {
      this.$refs.outwardOrderForm.resetFields();
      this.addOutwardForm = { };
    },
    async getOutwardStatusList() {
      const res = await apiOutwardStatusList();
      if (res.code == 0) {
        this.pullDownData.outwardStatusList = res.data;
      }
    },
    // 查询条件--开始日期
    startDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].endDate = this[formName].startDate;
      }
    },
    // 查询条件--结束日期
    endDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].startDate = this[formName].endDate;
      }
    },    
    // 表格数据
    async getOutwardOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiOutwardOrderSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        if (this.toolsLink == "firstLink") {
          this.searchConditionForm = {};
          this.pagination.currentPage = 1;
          this.getOutwardOrderSearch();
        }
      }
    },
    // 确认查询
    onSearch() {
      if (this.tabPaneValue == "first") {
        if (this.toolsLink == "firstLink") {
          this.pagination.currentPage = 1;
          this.getOutwardOrderSearch();
        }
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getOutwardOrderSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getOutwardOrderSearch();
    },    
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getOutwardOrderSearch();
    },    
    callback() {
      this.getOutwardStatusList();
      this.getProductTypeList();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      if (this.toolsLink == "firstLink") {
        this.getOutwardOrderSearch("", this.callback);
      } else {
        this.$nextTick(() => {
          this.$refs.commandPage.getFactoryCommandSearch("", this.callback);
        });
      }
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>
<style lang="less" scoped>
.none_border {width:265px; margin: left 2px;; display: -moz-inline-box; display: inline-block;}
</style>